<template>
  <div class="subscribe">
    <template v-if="userTickets&&userTickets.length > 0">
      <div class="subscribe-box">
        <div class="subscribe-item" v-for="(item, index) in userTickets" :key="index">
          <template v-if="item.goodsname.toLowerCase().indexOf('netflix') > -1">
            <div style="
              width: 100%;
              padding-top: 1%;
              background: linear-gradient(223deg,#603084 0%,#603084 0%,#4b9c9d 100%);
              border-radius: 10px;
              position: relative;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
              border: 1px solid rgb(249, 249, 249);
            ">
              <div class="justify-center" style="width: 100%; height: 150px; margin-top: 6%">
                <div style="
                  width: 90%;
                  color: white;
                  display: flex;
                  flex-wrap: nowrap;
                  justify-content: space-around;
                  height: 70px;
                ">
								<span style="font-family: DIN-Bold-; font-weight: bolder">Netflix-<span
                    style="font-family: MingLiU-ExtB; font-weight: normal">ALONGSHAR
										VIP</span></span>
                  <!-- <el-button style="background-color: #4A9F9C;border: 0;height: 30px;" type="primary" size="small" round @click="getGoodsspuByIdInfo(item.goodsSpu.id)">Renew now</el-button> -->
                  <!--                                <el-button style="background-color: #4A9F9C;border: 0;height: 30px;" type="primary" size="small" round @click="getGoodsspuByIdInfo(item.goodsSpu.id)">계속 구매</el-button>-->
                  <el-button style="background-color: #4a9f9c; border: 0; height: 30px" type="primary"
                             size="small" round
                             @click="getGoodsspuByIdInfo(item.goodsid, item.seatno)">
                    {{ $t("subscribe.renewnow") }}
                  </el-button>
                </div>
              </div>
              <div class="justify-center" style="width: 100%; position: absolute; top: 100px; z-index: 999">
                <div style="
                  font-size: 12px;
                  color: white;
                  width: 80%;
                  background: linear-gradient(142deg, #5f2f83 0%, #4a9f9c 100%);
                  box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.15);
                  border-radius: 10px;
                ">
                  <div style="
                    margin-top: 5%;
                    display: flex;
                    justify-content: space-around;
                  ">
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/noreplace.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">Renew the same subscription without changing</span> -->
                      <!--                                        <span class="textdesc">같은 제품을 계속 구매</span>-->
                      <span class="textdesc">{{
                          $t("subscribe.subscription")
                        }}</span>
                    </div>
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/4k.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">4K+HDR HD, independent viewing record</span> -->
                      <!--                                        <span class="textdesc">4K+HDR HD, 독립 시청 기록</span>-->
                      <span class="textdesc">{{
                          $t("subscribe.independent")
                        }}</span>
                    </div>
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/refundensure.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">money-back guarantee</span> -->
                      <!--                                        <span class="textdesc">환불 보증</span>-->
                      <span class="textdesc">{{
                          $t("subscribe.guarantee")
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="
                width: 100%;
                background-color: #f6f6f6;
                padding-top: 120px;
                font-size: 12px;
              ">
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Time left</span> -->
                    <!--                                    <span style="color: black">남은 시간</span>-->
                    <span style="color: black">{{
                        $t("subscribe.timeleft")
                      }}</span>
                    <!--倒计时  剩余时间-->
                    <span style="color: red">{{ item.ext1 }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account opening time</span> -->
                    <!--                                    <span style="color: black">계좌 개설 시간</span>-->
                    <span style="color: black">{{
                        $t("subscribe.openingtime")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.startTime }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">End Time</span> -->
                    <!--                                    <span style="color: black">종료 시간</span>-->
                    <span style="color: black">{{
                        $t("subscribe.endtime")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.endTime }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account</span> -->
                    <!--                                    <span style="color: black">계정</span>-->
                    <span style="color: black">{{
                        $t("subscribe.account")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.loginemail }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div class="psdinput psd-item">
                      <!-- <span style="color: black">Password</span> -->
                      <!--                                        <span style="color: black">비밀번호</span>-->
                      <span style="color: black">{{
                          $t("subscribe.password")
                        }}</span>
                      <div class="pass-input" style="color: #8e8e8e">
                        <el-input style="font-size: 1.2rem" type="password" v-model="item.loginpwd"
                                  show-password></el-input>
                      </div>
                    </div>
                    <!--                                    <div style="height: 25px;margin-top: 10px;">-->
                    <!--                                        <el-button class="resetpwd" type="primary" size="small" round @click="resetpwd(item)">reset Password</el-button>-->
                    <!--                                    </div>-->
                  </div>
                </div>
                <!-- 获取链接 -->
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div class="psdinput">
                      <div>
											<span style="color: black; font-weight: bolder">
												{{ $t("subscribe.getverificationlink") }}
                        <!-- Get login verification link -->
											</span>
                      </div>
                      <div style="padding-top: 5px">
											<span style="
                          font-size: 0.6rem;
                          color: rgb(219 107 107);
                          font-weight: bold;
                        ">
												<!-- If you have not been asked to fill in the verification
                        code,please ignorethis feature. -->
												{{ $t("subscribe.getlinktips") }}
											</span>
                      </div>
                      <div class="gtlink" @click="getlink(item.loginemail)">
                        <!-- {{!showlinkbt?'Click to get link' : 'Already resent ? Get again'}} -->
                        {{
                          !showlinkbt
                              ? $t("subscribe.clickto")
                              : $t("subscribe.Resend")
                        }}
                      </div>
                      <div v-if="showlinkbt">
                        <el-button type="primary" style="width: 100%" @click="openurl">get Netflix
                          code
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="justify-center" v-if="item.num == 1">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                      <!-- <span style="color: black">Profile</span> -->
                      <!--                                        <span style="color: black">소개</span>-->
                      <span style="color: black">{{
                          $t("subscribe.profile")
                        }}</span>
                      <!--                                        <span style="color: #8E8E8E">사용 해주세요 NO.-->
                      <span style="color: #8e8e8e">{{ $t("subscribe.pleaseuse") }} NO.

											<span style="
                          background-color: #5e2d82;
                          padding: 2px 5px;
                          color: white;
                        ">{{ item.seatno + 1 }}</span>
                        <!-- sub account</span> -->
                        <!--                                            서브 계정</span>-->
											{{ $t("subscribe.subaccount") }}</span>
                    </div>
                    <!-- 个人资料滥用 -->
                    <!-- <div style="height: 30px; margin-top: 10px"> -->
                    <!-- <el-button style="height: 30px;border: 1px solid #8E8E8E;background-color: #ffffff;color: #8E8E8E" type="primary" size="small" round @click="remind(item)">
                                              <icon-font type="icon-jinggao" style="margin-right: 5px;"/> -->
                    <!-- My profile is misused by someone! -->
                    <!--                                            내 프로필이 누군가에 의해 오용되었습니다！-->
                    <!-- {{$t('subscribe.myprofile')}}
                                          </el-button> -->
                    <!-- </div> -->
                    <div class="subscribe-badge">
                      <el-badge value="1" class="item" v-if="item.avatar0">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar0"></el-avatar>
                      </el-badge>
                      <el-badge value="1" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-netflix.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="2" class="item" v-if="item.avatar1">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar1"></el-avatar>
                      </el-badge>
                      <el-badge value="2" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-netflix.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="3" class="item" v-if="item.avatar2">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar2"></el-avatar>
                      </el-badge>
                      <el-badge value="3" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-netflix.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="4" class="item" v-if="item.avatar3">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar3"></el-avatar>
                      </el-badge>
                      <el-badge value="4" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-netflix.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="5" class="item" v-if="item.avatar4">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar4"></el-avatar>
                      </el-badge>
                      <el-badge value="5" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-netflix.png`"></el-avatar>
                      </el-badge>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; font-size: 16px; color: white">
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    display: flex;
                    justify-content: space-around;
                    height: 60px;
                    line-height: 60px;
                  ">
                    <!--                                    <span @click="getGoodsspuByIdInfo(item.goodsSpu.id)" style="cursor: pointer">Renew</span>-->
                    <span @click="getGoodsspuByIdInfo(item.goodsid)"
                          style="cursor: pointer">{{ $t("subscribe.renew") }}</span>
                    <div class="dashed"></div>
                    <!-- <router-link to="help" style="color: white">Help</router-link> -->
                    <!-- <router-link to="help" style="color: white">돕다</router-link>
                                      <div class="dashed"></div> -->
                    <!-- <router-link to="aftersales" style="color: white">After sales</router-link> -->
                    <!--                                    <router-link to="aftersales" style="color: white">애프터 서비스</router-link>-->
                    <router-link to="aftersales" style="color: white">{{
                        $t("subscribe.aftersales")
                      }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div style="
              background: linear-gradient(267deg, #5f3786 0%, #4b9c9d 100%);
              border-radius: 10px;
              margin-top: 3%;
            ">
              <div class="justify-center">
                <div style="
                  color: white;
                  font-size: 12px;
                  width: 80%;
                  margin-top: 3%;
                ">
                  <!-- <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">1.Please use your own sub account according to the serial number</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">2.Do not modify/delete other sub-accounts</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">3.Do not modify subscription-related information</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">Reminder: If you encounter any problems, please contact customer service in time, buy a subscription at alongshare, enjoy VIP customer service, and do not need to change the number for renewal.</span></p> -->

                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.yourownsub") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">1.일련번호에 따라-->
                  <!--                                        본인 서브계정을 이용해주세요.</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.delete") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">2.다른 하위 계정을-->
                  <!--                                        수정/삭제하지 마십시오.</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.modifysubscription") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">3.구독 관련 정보-->
                  <!--                                        수정 금지</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.reminder") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">알림 ：어떤 문제가-->
                  <!--                                        발생할 경우 즉시 고객 서비스에 연락하여 Along Share에서 서브스크립션을 구매하여 VIP 고객 서비스를 즐기실 수 있으며, 리필 시 번호 변경이-->
                  <!--                                        필요 없습니다.</span></p>-->
                </div>
              </div>
            </div>
          </template>
          <!-- disney -->
          <template v-else-if="item.goodsname.toLowerCase().indexOf('disney') > -1">
            <div style="
              width: 100%;
              padding-top: 1%;
              margin: 0.5%;
              background: linear-gradient(62deg, #1daedb 0%, #040244 100%);
              border-radius: 10px;
              border: 1px solid rgb(249, 249, 249);
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
              position: relative;

            ">
              <div class="justify-center" style="width: 100%; height: 150px; margin-top: 6%">
                <div style="
                  width: 90%;
                  color: white;
                  display: flex;
                  flex-wrap: nowrap;
                  justify-content: space-around;
                  height: 70px;
                ">
								<span style="font-family: DIN-Bold-; font-weight: bolder">Disney-<span
                    style="font-family: MingLiU-ExtB; font-weight: normal">ALONGSHAR
										VIP</span></span>
                  <!-- <el-button style="background: linear-gradient(316deg, #1893C2 0%, #90DFF8 100%);box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.35);border: 0;height: 30px;" type="primary" size="small" round @click="getGoodsspuByIdInfo(item.goodsSpu.id)">renew now</el-button> -->
                  <el-button style="
                    background: linear-gradient(316deg,#1893c2 0%,#90dff8 100%);
                    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.35);
                    border: 0;
                    height: 30px;
                  " type="primary" size="small" round
                             @click="getGoodsspuByIdInfo(item.goodsid)">{{ $t("subscribe.renewnow") }}
                  </el-button>
                </div>
              </div>
              <div class="justify-center" style="width: 100%; position: absolute; top: 100px; z-index: 999">
                <div style="
                  font-size: 12px;
                  color: white;
                  width: 80%;
                  background: linear-gradient(145deg, #040244 0%, #1cb1dc 100%);
                  box-shadow: 0px 9px 10px 0px rgba(0, 0, 0, 0.15);
                  border-radius: 10px;
                ">
                  <div style="
                    margin-top: 5%;
                    display: flex;
                    justify-content: space-around;
                  ">
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/noreplace.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">Renew the same subscription without changing</span> -->
                      <span class="textdesc">{{
                          $t("subscribe.subscription")
                        }}</span>
                    </div>
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/4k.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">4K+HDR HD, independent viewing record</span> -->
                      <span class="textdesc">{{
                          $t("subscribe.independent")
                        }}</span>
                    </div>
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/refundensure.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">money-back guarantee</span> -->
                      <span class="textdesc">{{
                          $t("subscribe.guarantee")
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="
                width: 100%;
                background-color: #f6f6f6;
                padding-top: 120px;
                font-size: 12px;
              ">
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Time left</span> -->
                    <span style="color: black">{{
                        $t("subscribe.timeleft")
                      }}</span>
                    <!--倒计时  剩余时间-->
                    <span style="color: red">{{ item.ext1 }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account opening time</span> -->
                    <span style="color: black">{{
                        $t("subscribe.openingtime")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.startTime }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">End Time</span> -->
                    <span style="color: black">{{
                        $t("subscribe.endtime")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.endTime }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account</span> -->
                    <span style="color: black">{{
                        $t("subscribe.account")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.loginemail }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div class="psdinput psd-item">
                      <!-- <span style="color: black">Password</span> -->
                      <span style="color: black">{{ $t("subscribe.password") }}</span>
                      <div style="color: #8e8e8e">
                        <el-input type="password" style="font-size: 1.2rem" v-model="item.loginpwd"
                                  show-password></el-input>
                      </div>
                    </div>
                    <!--                                    <div style="height: 25px;margin-top: 10px;">-->
                    <!--                                        <el-button class="resetpwd" type="primary" size="small" round @click="resetpwd(item)">Reset Password</el-button>-->
                    <!--                                    </div>-->
                  </div>
                </div>
                <div class="justify-center" v-if="item.num == 1">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                      <!-- <span style="color: black">Profile</span> -->
                      <span style="color: black">{{
                          $t("subscribe.profile")
                        }}</span>
                      <!-- <span style="color: #8E8E8E">please use NO. <span style="background-color: #3C85D5;padding:2px 5px;color: white">{{item.seatno+1}}</span> sub account</span> -->
                      <span style="color: #8e8e8e">{{ $t("subscribe.pleaseuse") }} NO.
											<span style="
                          background-color: #3c85d5;
                          padding: 2px 5px;
                          color: white;
                        ">{{ item.seatno + 1 }}</span>
											{{ $t("subscribe.subaccount") }}
										</span>
                    </div>
                    <div style="height: 30px; margin-top: 10px">
                      <!-- <el-button style="height: 30px;border: 1px solid #8E8E8E;background-color: #ffffff;color: #8E8E8E" type="primary" size="small" round @click="remind(item)">
                                              <icon-font type="icon-jinggao" style="margin-right: 5px;"/> -->
                      <!-- My profile is misused by someone! -->
                      <!--                                            내 프로필이 누군가에 의해 오용되었습니다！-->
                      <!-- {{$t('subscribe.myprofile')}}
                                          </el-button> -->
                    </div>
                    <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      margin-top: 20px;
                    ">
                      <el-badge value="1" class="item" v-if="item.avatar0">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar0"></el-avatar>
                      </el-badge>
                      <el-badge value="1" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="2" class="item" v-if="item.avatar1">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar1"></el-avatar>
                      </el-badge>
                      <el-badge value="2" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="3" class="item" v-if="item.avatar2">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar2"></el-avatar>
                      </el-badge>
                      <el-badge value="3" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="4" class="item" v-if="item.avatar3">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar3"></el-avatar>
                      </el-badge>
                      <el-badge value="4" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="5" class="item" v-if="item.avatar4">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar4"></el-avatar>
                      </el-badge>
                      <el-badge value="5" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; font-size: 16px; color: white">
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    display: flex;
                    justify-content: space-around;
                    height: 60px;
                    line-height: 60px;
                  ">
                    <!-- <span @click="getGoodsspuByIdInfo(item.goodsSpu.id)" style="cursor: pointer">Renew</span> -->
                    <span @click="getGoodsspuByIdInfo(item.goodsid)" style="cursor: pointer">
										{{ $t("subscribe.renew") }}</span>
                    <div class="dashed"></div>
                    <!-- <router-link to="help" style="color: white">Help</router-link> -->
                    <!-- <router-link to="help" style="color: white">돕다</router-link> -->

                    <div class="dashed"></div>
                    <!-- <router-link to="aftersales" style="color: white">After sales</router-link> -->
                    <router-link to="aftersales" style="color: white">{{
                        $t("subscribe.aftersales")
                      }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div style="
              background: linear-gradient(144deg, #1cb1dc 0%, #030747 100%);
              border-radius: 10px;
              margin-top: 3%;
            ">
              <div class="justify-center">
                <!-- <div style="color: white;font-size: 12px;width: 80%;margin-top: 3%">
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">1.Please use your own sub account according to the serial number</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">2.Do not modify/delete other sub-accounts</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">3.Do not modify subscription-related information</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">Reminder: If you encounter any problems, please contact customer service in time, buy a subscription at alongshare, enjoy VIP customer service, and do not need to change the number for renewal.</span></p>
                              </div> -->
                <div style="
                  color: white;
                  font-size: 12px;
                  width: 80%;
                  margin-top: 3%;
                ">
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.yourownsub") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">1.일련번호에 따라-->
                  <!--                                        본인 서브계정을 이용해주세요.</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.delete") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">2.다른 하위 계정을-->
                  <!--                                        수정/삭제하지 마십시오.</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.modifysubscription") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">3.구독 관련 정보-->
                  <!--                                        수정 금지</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.reminder") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">알림 ：어떤 문제가-->
                  <!--                                        발생할 경우 즉시 고객 서비스에 연락하여 Along Share에서 서브스크립션을 구매하여 VIP 고객 서비스를 즐기실 수 있으며, 리필 시 번호 변경이-->
                  <!--                                        필요 없습니다.</span></p>-->
                </div>
              </div>
            </div>
          </template>
          <div v-else-if="item.goodsname.toLowerCase().indexOf('chat gpt') > -1">
            <div style="
              width: 100%;
              padding-top: 1%;
              margin: 0.5%;
              background: #ffffff;
              border-radius: 10px;
              border: 1px solid rgb(249, 249, 249);
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            ">
              <div class="justify-center" style="width: 100%; height: 50px; margin-top: 6%">
                <div style="
                  width: 90%;
                  color: white;
                  display: flex;
                  flex-wrap: nowrap;
                  justify-content: space-around;
                  height: 70px;
                ">
								<span style="
                    font-family: DIN-Bold-;
                    font-weight: bolder;
                    color: black;
                  ">
									<!-- Youtube premium -->
									Chat GPT4.0

                  <!-- Spotify 名字 -->
								</span>
                  <el-button style="
                    background: linear-gradient(270deg, #43d98e 0%,#b4f4d4 100%);
                    border: 0;
                    height: 30px;
                  " type="primary" size="small" round
                             @click="getGoodsspuByIdInfo(item.goodsid)">{{ $t("subscribe.renewnow") }}
                  </el-button>
                </div>
              </div>
              <div style="width: 100%; background-color: #f6f6f6; font-size: 12px">
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Time left</span> -->
                    <span style="color: black">{{
                        $t("subscribe.timeleft")
                      }}</span>
                    <!--倒计时  剩余时间-->
                    <span style="color: red">{{ item.ext1 }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account opening time</span> -->
                    <span style="color: black">{{
                        $t("subscribe.openingtime")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.startTime }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">End Time</span> -->
                    <span style="color: black">{{
                        $t("subscribe.endtime")
                      }}</span>

                    <span style="color: #8e8e8e">{{ item.endTime }}</span>
                  </div>
                </div>
                <!-- 密码 -->
                <!-- <div class="justify-center">
                  <div
                    style="
                      width: 80%;
                      padding: 10px;
                      margin: 5px;
                      display: flex;
                      justify-content: space-between;
                      border: 1px solid #ebeef5;
                      border-radius: 10px;
                    "
                  > -->
                <!-- <span style="color: black">Account</span> -->
                <!-- <span style="color: black">{{
                      $t("subscribe.account")
                    }}</span>
                    <span style="color: #8e8e8e">{{ item.loginemail }}</span>
                  </div> -->
                <!-- </div> -->
                <!-- <div class="justify-center">
                  <div
                    style="
                      width: 80%;
                      padding: 10px;
                      margin: 5px;
                      border: 1px solid #ebeef5;
                      border-radius: 10px;
                    "
                  >
                    <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        width: 100%;
                        align-items: center;
                      "
                      class="psdinput"
                    > -->
                <!-- <span style="color: black">Password</span> -->
                <!-- <span style="color: black">{{
                        $t("subscribe.password")
                      }}</span>
                      <span style="color: #8e8e8e">
                        <el-input
                          type="password"
                          style="font-size: 1.2rem"
                          v-model="item.loginpwd"
                          show-password
                        ></el-input>
                      </span>
                    </div> -->
                <!--                                    <div style="height: 25px;margin-top: 10px;">-->
                <!--                                        <el-button class="resetpwd" type="primary" size="small" round @click="resetpwd(item)">Reset Password</el-button>-->
                <!--                                    </div>-->
                <!-- </div> -->
                <!-- </div> -->
                <!--  -->
                <div class="justify-center">

                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div class="psdinput psd-item">
                      <span style="color: black">Token</span>
                      <span style="color: black;display: flex;align-items: center;">
											<!-- {{$t("subscribe.password")}} -->
										</span>
                      <!-- Token -->
                      <span style="color: #8e8e8e">
											<el-input style="font-size:1.2rem;display: flex;" type="password"
                                v-model="item.loginpwd" show-password></el-input>
										</span>
                    </div>
                    <!-- 重置密码 -->
                    <!--                                    <div style="height: 25px;margin-top: 10px;">-->
                    <!--                                        <el-button class="resetpwd" type="primary" size="small" round @click="resetpwd(item)">Reset Password</el-button>-->
                    <!--                                    </div>-->
                  </div>
                </div>
                <!-- token按钮 -->
                <div class="justify-center">
                  <div style="width: 80%">
                    <div style="padding: 10px 0" v-if="!showjoin">
                      <el-button type="primary" style="width: 100%" @click="openchat">Open
                        GPT
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 底部按钮 -->
              <div style="
                width: 100%;
                font-size: 16px;
                background-color: #43d98e;
                color: #ffffff;
                : 5px;
                border-bottom-right-radius: 5px;
              ">
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    display: flex;
                    justify-content: space-around;
                    height: 60px;
                    line-height: 60px;
                  ">
                    <!-- <span @click="getGoodsspuByIdInfo(item.goodsSpu.id)" style="cursor: pointer">Renew</span> -->
                    <span @click="getGoodsspuByIdInfo(item.goodsid)"
                          style="cursor: pointer">{{ $t("subscribe.renew") }}</span>
                    <div class="dashed"></div>
                    <!-- <router-link to="help" style="color: white">Help</router-link>
                                      <div class="dashed"></div> -->
                    <router-link to="aftersales" style="color: white">{{
                        $t("subscribe.aftersales")
                      }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
            <!-- 底部 -->
          </div>
          <!-- 油管 -->
          <div v-else>
            <div style="
              width: 100%;
              padding-top: 1%;
              margin: 0.5%;
              background: #fff;
              border-radius: 10px;
              border: 1px solid rgb(249, 249, 249);
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            ">
              <div class="justify-center" style="width: 100%; height: 50px; margin-top: 6%;">
                <div style="
                  width: 90%;
                  color: white;
                  display: flex;
                  flex-wrap: nowrap;
                  justify-content: space-around;
                  height: 70px;
                ">
								<span style="
                    font-family: DIN-Bold-;
                    font-weight: bolder;
                    color: black;
                  ">
									<!-- Youtube premium -->
									{{
                    item.num == 1 &&
                    item.goodsname.toLowerCase().indexOf("youtube") ==
                    -1
                        ? item.goodsname
                        : "Youtube premium"
                  }}
                  <!-- Spotify -->
								</span>
                  <el-button style="
                    background: linear-gradient(270deg,#43d98e 0%,#b4f4d4 100%);
                    border: 0;
                    height: 30px;
                  " type="primary" size="small" round
                             @click="getGoodsspuByIdInfo(item.goodsid)">{{ $t("subscribe.renewnow") }}
                  </el-button>
                </div>
              </div>
              <div class="justify-center" style="width: 100%;background: rgb(246, 246, 246);">
                <div style="
                  font-size: 12px;
                  color: #8e8e8e;
                  width: 80%;
                  border-radius: 10px;
                ">
                  <div class="dashed-green"></div>
                  <div style="
                    margin-top: 5%;
                    display: flex;
                    justify-content: space-around;
                  ">
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/noreplace-green.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">Renew the same subscription without changing</span> -->
                      <span class="textdesc">{{
                          $t("subscribe.subscription")
                        }}</span>
                    </div>
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/4k-green.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">4K+HDR HD, independent viewing record</span> -->
                      <span class="textdesc">{{
                          $t("subscribe.independent")
                        }}</span>
                    </div>
                    <div style="width: 25%">
                      <img :src="`${$g.imgPrefix}/frontend/refundensure-green.png`"
                           width="100%"/>
                      <!-- <span class="textdesc">money-back guarantee</span> -->
                      <span class="textdesc">{{
                          $t("subscribe.guarantee")
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="width: 100%; background-color: #f6f6f6; font-size: 12px">
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Time left</span> -->
                    <span style="color: black">{{
                        $t("subscribe.timeleft")
                      }}</span>
                    <!--倒计时  剩余时间-->
                    <span style="color: red">{{ item.ext1 }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account opening time</span> -->
                    <span style="color: black">{{
                        $t("subscribe.openingtime")
                      }}</span>
                    <span style="color: #8e8e8e">{{ item.startTime }}</span>
                  </div>
                </div>
                <div class="justify-center">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">End Time</span> -->
                    <span style="color: black">{{
                        $t("subscribe.endtime")
                      }}</span>

                    <span style="color: #8e8e8e">{{ item.endTime }}</span>
                  </div>
                </div>
                <div class="justify-center" v-if="
                  item.goodsname.toLowerCase().indexOf('youtube') == -1
                ">
                  <div class="subscribe-form-item">
                    <!-- <span style="color: black">Account</span> -->
                    <span style="color: black">{{
                        $t("subscribe.account")
                      }}</span>

                    <span style="color: #8e8e8e">{{ item.loginemail }}</span>
                  </div>
                </div>
                <div class="justify-center" v-if="
                  item.goodsname.toLowerCase().indexOf('youtube') == -1
                ">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div class="psdinput psd-item">
                      <!-- <span style="color: black">Password</span> -->
                      <span style="color: black">{{
                          $t("subscribe.password")
                        }}</span>
                      <div style="color: #8e8e8e">
                        <el-input style="font-size: 1.2rem" type="password" v-model="item.loginpwd"
                                  show-password></el-input>
                      </div>
                    </div>
                    <!--                                    <div style="height: 25px;margin-top: 10px;">-->
                    <!--                                        <el-button class="resetpwd" type="primary" size="small" round @click="resetpwd(item)">Reset Password</el-button>-->
                    <!--                                    </div>-->
                  </div>
                </div>
                <div class="justify-center" v-if="
                  item.num == 1 &&
                  item.goodsname.toLowerCase().indexOf('youtube') == -1
                ">
                  <div style="
                    width: 80%;
                    padding: 10px;
                    margin: 5px;
                    border: 1px solid #ebeef5;
                    border-radius: 10px;
                  ">
                    <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                    ">
                      <!-- <span style="color: black">Profile</span> -->
                      <span style="color: black">{{
                          $t("subscribe.profile")
                        }}</span>
                      <!-- <span style="color: #8E8E8E">please use NO. <span style="background-color: #43D98E;padding:2px 5px;color: white">{{item.seatno+1}}</span> sub account</span> -->
                      <span style="color: #8e8e8e">{{ $t("subscribe.pleaseuse") }} NO.
											<span style="
                          background-color: #43d98e;
                          padding: 2px 5px;
                          color: white;
                        ">{{ item.seatno + 1 }}</span>
											{{ $t("subscribe.subaccount") }}</span>
                    </div>
                    <div style="height: 30px; margin-top: 10px">
                      <!-- 资料按钮 -->
                      <!-- <el-button style="height: 30px;border: 1px solid #8E8E8E;background-color: #ffffff;color: #8E8E8E" type="primary" size="small" round @click="remind(item)">
                                              <icon-font type="icon-jinggao" style="margin-right: 5px;"/> -->
                      <!-- My profile is misused by someone! -->
                      <!--                                            내 프로필이 누군가에 의해 오용되었습니다！-->
                      <!-- {{$t('subscribe.myprofile')}}
                                          </el-button> -->
                    </div>
                    <div style="
                      display: flex;
                      justify-content: space-between;
                      width: 100%;
                      margin-top: 20px;
                    ">
                      <el-badge value="1" class="item" v-if="item.avatar0">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar0"></el-avatar>
                      </el-badge>
                      <el-badge value="1" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="2" class="item" v-if="item.avatar1">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar1"></el-avatar>
                      </el-badge>
                      <el-badge value="2" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="3" class="item" v-if="item.avatar2">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar2"></el-avatar>
                      </el-badge>
                      <el-badge value="3" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="4" class="item" v-if="item.avatar3">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar3"></el-avatar>
                      </el-badge>
                      <el-badge value="4" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                      <el-badge value="5" class="item" v-if="item.avatar4">
                        <el-avatar shape="square" :size="50"
                                   :src="item.avatar4"></el-avatar>
                      </el-badge>
                      <el-badge value="5" class="item" v-else>
                        <el-avatar shape="square" :size="50"
                                   :src="`${$g.imgPrefix}/frontend/subscribe-disney.png`"></el-avatar>
                      </el-badge>
                    </div>
                  </div>
                </div>
                <div class="justify-center" v-if="
                  item.goodsname.toLowerCase().indexOf('youtube') > -1
                ">
                  <div style="width: 80%">
                    <div style="
                      background-color: #e8f2fe;
                      padding: 10px;
                      border-radius: 10px;
                    ">
                      <div>
                        <div style="color: #2496f3">
                          <!-- Enter your YouTube login email. Be sure to use your login email address to join the family group,
                                                  otherwise you will be kicked out of the family. If you need help, please contact Alongshare Customer Service via email on the -->
                          <!-- YouTube 로그인 이메일을 입력하세요. 로그인 이메일 주소를
                          사용하여 가족 그룹에 가입해야 합니다. 그렇지 않으면
                          가족에서 쫓겨날 것입니다. 도움이 필요하시면 이메일을
                          통해 Alongshare 고객 서비스에 문의하십시오.
                          play.google.com 계정 국가/지역을 확인하세요: KR, ES, FR, PL,
                          IT, DE, NL, GB, CA, US, JP, GR, CH, LT, PA, SG, CZ, SE,
                          PT, BE , 일리노이. 문제가 발생하면 시간 내에 티켓을 통해
                          직원에게 문의하십시오. -->
                          가입 시 "Not in a country" 팝업이 표시되는 경우
                          <a
                              href="https://pay.google.com/gp/w/u/0/home/settings">https://pay.google.com/gp/w/u/0/home/settings</a>
                          설정에서 모든 청구 주소를 삭제하려면 이 URL로 이동하세요
                          . 그런 다음 등록할 수 있습니다.<br/>
                          {{ $t("subscribe.youtubeloginemail") }}
                          <!--                                                <router-link to="aftersales" style="margin: 5px;color: #217CD6">애프터 서비스</router-link>-->
                          <router-link to="aftersales"
                                       style="margin: 5px; color: #217cd6">{{ $t("subscribe.aftersalesservice") }}
                          </router-link>
                          <!--                                                지원 페이지.-->
                          {{ $t("subscribe.support") }}
                        </div>
                      </div>
                    </div>
                    <div style="padding: 10px 0" v-if="!showjoin">
                      <el-form :model="form" :rules="rules" ref="ruleForm">
                        <el-form-item prop="content">
                          <el-input v-model="form.content"
                                    placeholder="YouTube login email"></el-input>
                        </el-form-item>
                        <!-- <el-button type="primary" style="width: 100%" @click="submitUser(item.id)">submit</el-button> -->
                        <!--                                            <el-button type="primary" style="width: 100%" @click="submitUser(item.id)">제출하다</el-button>-->
                        <el-button type="primary" style="width: 100%"
                                   @click="submitUser(item.id, item.loginemail)">{{ $t("subscribe.submit") }}
                        </el-button>
                      </el-form>
                    </div>
                    <!-- <span style="color: #000">{{ item.loginemail }}</span> -->
                    <!-- join YouTube 按钮 -->
                    <div v-if="showjoin">
                      <div style="
                        margin: 10px 0;
                        display: flex;
                        justify-content: space-between;
                      ">
											<span style="color: #8e8e8e; width: 75%">
												<el-input style="flex: 1" v-model="item.loginemail"
                                  id="copyText"></el-input>
											</span>
                        <el-button @click="copy">copy</el-button>
                      </div>
                      <div style="margin: 10px 0">
                        <el-button type="primary" style="width: 100%"
                                   @click="joinyoutube(item.loginemail)">Join
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="
                width: 100%;
                font-size: 16px;
                background-color: #43d98e;
                color: #ffffff;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;
              ">
                <div class="justify-center">
                  <div style="
                    width: 80%;
                    display: flex;
                    justify-content: space-around;
                    height: 60px;
                    line-height: 60px;
                  ">
                    <!-- <span @click="getGoodsspuByIdInfo(item.goodsSpu.id)" style="cursor: pointer">Renew</span> -->
                    <span @click="getGoodsspuByIdInfo(item.goodsid)"
                          style="cursor: pointer">{{ $t("subscribe.renew") }}</span>
                    <div class="dashed"></div>
                    <!-- <router-link to="help" style="color: white">Help</router-link>
                                      <div class="dashed"></div> -->
                    <router-link to="aftersales" style="color: white">{{
                        $t("subscribe.aftersales")
                      }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>

            <div style="background: #226c47; border-radius: 10px; margin-top: 3%">
              <div class="justify-center">
                <!-- <div style="color: white;font-size: 12px;width: 80%;margin-top: 3%">
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">1.Please use your own sub account according to the serial number</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">2.Do not modify/delete other sub-accounts</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">3.Do not modify subscription-related information</span></p>
                                  <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">Reminder: If you encounter any problems, please contact customer service in time, buy a subscription at alongshare, enjoy VIP customer service, and do not need to change the number for renewal.</span></p> -->
                <div style="
                  color: white;
                  font-size: 12px;
                  width: 80%;
                  margin-top: 3%;
                ">
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.yourownsub") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">1.일련번호에 따라-->
                  <!--                                        본인 서브계정을 이용해주세요.</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.delete") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">2.다른 하위 계정을-->
                  <!--                                        수정/삭제하지 마십시오.</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.modifysubscription") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">3.구독 관련 정보-->
                  <!--                                        수정 금지</span></p>-->
                  <p>
									<span style="
                      font-size: 10pt;
                      font-family: 'book antiqua', palatino, serif;
                    ">{{ $t("subscribe.reminder") }}</span>
                  </p>
                  <!--                                <p><span style="font-size: 10pt; font-family: 'book antiqua', palatino, serif;">알림 ：어떤 문제가-->
                  <!--                                        발생할 경우 즉시 고객 서비스에 연락하여 Along Share에서 서브스크립션을 구매하여 VIP 고객 서비스를 즐기실 수 있으며, 리필 시 번호 변경이-->
                  <!--                                        필요 없습니다.</span></p>-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="subscribe-item" v-if="this.quotaData!=null">
            <!-- share ai -->
            <div v-if="quotaData!=null">
              <div style="
                width: 100%;
                padding-top: 1%;
                margin: 0.5%;
                background: #ffffff;
                border-radius: 10px;
                border: 1px solid rgb(249, 249, 249);
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
              ">
                <div class="justify-center" style="width: 100%; height: 50px; margin-top: 6%">
                  <div style="
                    width: 90%;
                    color: white;
                    display: flex;
                    flex-wrap: nowrap;
                    justify-content: space-around;
                    height: 70px;
                  ">
                  <span style="
                      font-family: DIN-Bold-;
                      font-weight: bolder;
                      color: black;
                    ">
                    <!-- Youtube premium -->
                    Share AI
  
                    <!-- Spotify 名字 -->
                  </span>
                    <!-- <el-button style="
                      background: linear-gradient(270deg, #43d98e 0%,#b4f4d4 100%);
                      border: 0;
                      height: 30px;
                    " type="primary" size="small" round
                               @click="getGoodsspuByIdInfo(item.goodsid)">{{ $t("subscribe.renewnow") }}
                    </el-button> -->
                  </div>
                </div>
                <div style="width: 100%; background-color: #f6f6f6; font-size: 12px">
                  <div class="justify-center">
                    <div class="subscribe-form-item">
                      <!-- <span style="color: black">Account opening time</span> -->
                      <span style="color: black">{{
                          $t("subscribe.openingtime")
                        }}</span>
                      <span style="color: #8e8e8e">{{ quotaData.startDate }}</span>
                    </div>
                  </div>
                  <div class="justify-center">
                    <div class="subscribe-form-item">
                      <!-- <span style="color: black">End Time</span> -->
                      <span style="color: black">{{
                          $t("subscribe.endtime")
                        }}</span>
  
                      <span style="color: #8e8e8e">{{ quotaData.endDate }}</span>
                    </div>
                  </div>
                  <div class="justify-center">
                    <div class="subscribe-form-item">
                      <!-- <span style="color: black">End Time</span> -->
                      <span style="color: black">{{
                          $t("subscribe.nextresetdate")
                        }}</span>
  
                      <span style="color: #8e8e8e">{{ quotaData.nextResetDate }}</span>
                    </div>
                  </div>
                  <div class="justify-center">
                    <div class="subscribe-form-item">
                      <!-- <span style="color: black">End Time</span> -->
                      <span style="color: black">{{
                          $t("subscribe.paidquota")
                        }}</span>
  
                      <span style="color: #8e8e8e">{{ quotaData.paidQuota }}</span>
                    </div>
                  </div>
                  <!-- <div class="justify-center">
  
                    <div style="
                      width: 80%;
                      padding: 10px;
                      margin: 5px;
                      border: 1px solid #ebeef5;
                      border-radius: 10px;
                    ">
                      <div class="psdinput psd-item">
                        <span style="color: black">Token</span>
                        <span style="color: black;display: flex;align-items: center;">

                      </span> -->
                        <!-- Token -->
                        <!-- <span style="color: #8e8e8e">
                        <el-input style="font-size:1.2rem;display: flex;" type="password"
                                  v-model="item.loginpwd" show-password></el-input>
                      </span>
                      </div>
                    </div>
                  </div> -->
                  <!-- token按钮 -->
                  <div class="justify-center">
                    <div style="width: 80%">
                      <div style="padding: 10px 0" v-if="!showjoin">
                        <el-button type="primary" style="width: 100%" @click="gochat">Share AI
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 底部按钮 -->
                <!-- <div style="
                  width: 100%;
                  font-size: 16px;
                  background-color: #43d98e;
                  color: #ffffff;
                  : 5px;
                  border-bottom-right-radius: 5px;
                ">
                  <div class="justify-center">
                    <div style="
                      width: 80%;
                      display: flex;
                      justify-content: space-around;
                      height: 60px;
                      line-height: 60px;
                    "> -->
                      <!-- <span @click="getGoodsspuByIdInfo(item.goodsSpu.id)" style="cursor: pointer">Renew</span> -->
                      <!-- <span @click="getGoodsspuByIdInfo(item.goodsid)"
                            style="cursor: pointer">{{ $t("subscribe.renew") }}</span>
                      <div class="dashed"></div> -->
                      <!-- <router-link to="help" style="color: white">Help</router-link>
                                        <div class="dashed"></div> -->
                      <!-- <router-link to="aftersales" style="color: white">{{
                          $t("subscribe.aftersales")
                        }}
                      </router-link>
                    </div>
                  </div>
                </div> -->
              </div>
              <!-- 底部 -->
            </div>
        </div>
      </div>

      <el-drawer :close-on-press-escape="false" :wrapperClosable="true" :visible.sync="drawer1" direction="rtl">
        <div style="width: 100%" class="justify-center">
          <div style="width: 90%">
            <div style="width: 70%" class="justify-between">
              <div class="block">
                <el-avatar :size="100" :src="spu.img"></el-avatar>
              </div>
              <div style="margin-left: 5%">
                <div style="margin-top: 10px">
                  <span style="color: #43d98e; font-weight: bolder; font-size: 1.8em">${{ price }}</span>
                  <del style="
                    color: red;
                    font-weight: bolder;
                    font-size: 1em;
                    margin-left: 10px;
                  " v-if="'' != originalprice && originalprice > price">${{ originalprice }}
                  </del>
                </div>
                <div style="font-size: 1em">
                  <!-- <span>{{ form1.num }} parking space</span> -->
                  <!--                                <span>{{ form1.num }} 위치</span>-->
                  <span>{{ form1.num }} {{ $t("home.parkingspace") }}</span>
                  <span style="margin-left: 10px">{{ month }}</span>
                </div>
                <div style="font-size: 1em; font-weight: bolder; color: red">
                  <!-- <span v-if="giftstimes > 0"> gift {{ giftstimes }} month</span> -->
                  <!--                                <span v-if="giftstimes > 0"> 선물 {{ giftstimes }} month</span>-->
                  <span v-if="giftstimes > 0">
									{{ $t("home.gift") }} {{ giftstimes }} month</span>
                </div>
              </div>
            </div>
            <el-form :model="form1" :rules="rules1" ref="ruleForm1">
              <div style="padding: 10px 0 0 10px">
                <!--                            <p>Month</p>-->
                <!--                            <p>구입 시간</p>-->
                <p>{{ $t("home.month") }}</p>
              </div>
              <!-- 						<el-form-item prop="skuid">
                            <el-radio-group v-model="form1.skuid" style="display: flex; flex-wrap: wrap"
                              @change="updatePrice">
                              <el-radio-button :label="item.id" v-for="(item, index) in spu.skus" :key="index"
                                class="skuname">{{ item.skuname }}</el-radio-button>
                            </el-radio-group>
                          </el-form-item> -->


              <!-- wangchuang  modifyed -->
              <el-form-item prop="skuid">
                <el-radio-group v-model="form1.skuid" style="display: flex; flex-wrap: wrap"
                                @change="updatePrice">
                  <el-radio-button :label="item.id" v-for="(item, index) in skuFilterList" :key="index"
                                   class="skuname">{{ item.skuname }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>

              <!--
              <el-divider></el-divider>
              <div style="padding-left: 10px">
                <p>{{ $t("home.screen") }}</p>
              </div>
              <el-form-item prop="num">

                <el-radio-group v-model="form1.num" style="display: flex" v-if="spu.type == '2'"
                  @change="updatePrice">
                  <el-radio-button label="1" class="skuname">{{
                    $t("home.1screen")
                  }}</el-radio-button>
                  <el-radio-button :label="spu.maxnum" class="skuname">{{ spu.maxnum }}
                    {{ $t("home.maxnum") }}</el-radio-button>
                </el-radio-group>
                <el-radio-group v-model="form1.num" style="display: flex" v-else @change="updatePrice">
                  <el-radio-button label="1" class="skuname">{{
                    $t("home.1screen")
                  }}</el-radio-button>
                </el-radio-group>

              </el-form-item> -->


              <!-- wangchuang  modifyed -->
              <el-form-item prop="num">

                <!-- 							<el-radio-group v-model="form1.num" style="display: flex" v-if="spu.type == '3'"
                                default-checked @change="updateSku">
                                <el-radio-button label="1" class="skuname">{{$t("home.1screen")}}</el-radio-button>
                                <el-radio-button label="2" class="skuname">{{ spu.maxnum }}
                                  {{ $t("home.maxnum") }}</el-radio-button>
                              </el-radio-group> -->

                <el-radio-group v-model="form1.num" style="display: flex" v-if="spu.num >1"
                                default-checked @change="updateSku">
                  <el-radio-button label="2" class="skuname">{{ spu.maxnum }}
                    {{ $t("home.maxnum") }}
                  </el-radio-button>
                </el-radio-group>


                <el-radio-group v-model="form1.num" style="display: flex" v-else
                                default-checked @change="updateSku">
                  <el-radio-button label="1" class="skuname">{{ $t("home.1screen") }}</el-radio-button>
                </el-radio-group>


              </el-form-item>


              <el-divider></el-divider>
              <div style="padding-left: 10px">
                <!-- <p>Buy Type</p> -->
                <!--                            <p>구매 유형</p>-->
                <p>{{ $t("home.buytyp") }}</p>
              </div>
              <el-form-item prop="buytype">
                <el-radio-group v-model="form1.buytype" style="display: flex">
                  <!-- <el-radio-button label="1" class="skuname">subscription</el-radio-button> -->
                  <!--                              <el-radio-button label="1" class="skuname">계정</el-radio-button>-->
                  <!-- <el-radio-button label="1" class="skuname">{{
                    $t("home.subscription")
                  }}</el-radio-button> -->

                  <el-radio-button label="1"
                                   class="skuname">{{ $t("home.newsubscription") }}
                  </el-radio-button>


                  <!-- <el-radio-button label="2" class="skuname">Voucher</el-radio-button> -->
                  <!--                                <el-radio-button label="2" class="skuname">상환 코드</el-radio-button>-->
                  <!-- <el-radio-button label="2" class="skuname">{{
                    $t("home.voucher")
                  }}</el-radio-button> -->
                </el-radio-group>
              </el-form-item>
              <el-divider></el-divider>
              <div style="padding-left: 10px">
                <!-- <span>Discount code</span> -->
                <!--                            <span>할인 코드</span>-->
                <span>{{ $t("home.discountcode") }}</span>
                <!-- <el-input type="text" v-model="form1.discountcode" placeholder="Discount code" -->
                <!--                            <el-input type="text" v-model="form1.discountcode" placeholder="할인 코드" style="width: 50%;margin-left: 2%" clearable></el-input>-->
                <el-input type="text" v-model="form1.discountcode" :placeholder="$t('home.discountcode')"
                          style="width: 50%; margin-left: 2%" clearable></el-input>
                <!-- <el-button type="primary" style="margin-left:3%" @click="useDiscountcode">Use</el-button> -->
                <!--                            <el-button type="primary" style="margin-left:3%" @click="useDiscountcode">사용</el-button>-->
                <el-button type="primary" style="margin-left: 3%"
                           @click="useDiscountcode">{{ $t("home.use") }}
                </el-button>
              </div>
              <el-divider></el-divider>
              <el-form-item style="padding-left: 10px" prop="paycode">
                <!-- <span>Payment method</span> -->
                <!--                            <span>지불 방법</span>-->
                <span>{{ $t("home.paymentmethod") }}</span>
                <!-- <el-select v-model="form1.paycode" placeholder="please choose" style="margin-left: 5%"> -->
                <el-select v-model="form1.paycode" :placeholder="$t('home.pleasechoose')"
                           style="margin-left: 5%">
                  <el-option v-for="item in payOptions" :key="item.code" :label="item.name"
                             :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <div style="padding: 50px 0">
                <!-- <el-button style="width: 100%" type="primary" round @click="soonbug">Buy now</el-button> -->
                <el-button style="width: 100%" type="primary" round
                           @click="soonbug">{{ $t("home.buynow") }}
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-drawer>

      <el-drawer :close-on-press-escape="false" :wrapperClosable="false" :visible.sync="drawer3" direction="rtl">
        <div style="width: 100%" class="justify-center">
          <div style="width: 90%">
            <div style="
              font-size: 1.5em;
              color: #43d98e;
              font-weight: bolder;
              font-family: Source Han Sans CN-Normal;
            ">
              <!-- <p>Credit Card</p> -->
              <p>신용 카드</p>
            </div>
            <el-form :model="form3" :rules="rules3" ref="ruleForm3" size="mini">
              <el-form-item prop="cardnumber">
                <!-- <el-input v-model="form3.cardnumber" placeholder="Card number"></el-input> -->
                <el-input v-model="form3.cardnumber" placeholder="카드 번호"></el-input>
              </el-form-item>
              <el-form-item prop="date">
                <el-date-picker style="width: 100%" v-model="form3.date" type="month" format="MM/yyyy"
                                value-format="yyyy-MM" placeholder="만료 날짜">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="cvv">
                <el-input v-model="form3.cvv" placeholder="CVC/CVV(3 digts)"></el-input>
              </el-form-item>
              <el-form-item prop="name">
                <!-- <el-input v-model="form3.name" placeholder="Name on card"></el-input> -->
                <el-input v-model="form3.name" placeholder="카드 소지자 이름"></el-input>
              </el-form-item>
              <el-form-item>
                <!-- <el-checkbox v-model="form3.issave">Save this card for future payments</el-checkbox> -->
                <el-checkbox v-model="form3.issave">향후 결제를 위해 이 카드를 저장하세요.</el-checkbox>
              </el-form-item>
              <div style="padding: 50px 0">
                <!-- <el-button style="width: 100%" type="primary" round @click="playorder">Play ${{price}}</el-button> -->
                <el-button style="width: 100%" type="primary" round @click="playorder">지불하다
                  ${{ price }}
                </el-button>
              </div>
            </el-form>
          </div>
        </div>
      </el-drawer>

      <el-drawer :close-on-press-escape="false" :wrapperClosable="false" :visible.sync="drawer4" direction="rtl">
        <div class="justify-center" style="margin-top: 30%">
          <el-result :title="payReslutTitle">
            <template slot="icon">
              <el-image :src="payReslutIcon" style="width: 80px; height: 80px"></el-image>
            </template>
          </el-result>
        </div>
      </el-drawer>
      <!-- payssion -->
      <el-drawer class="payssion-drawer" :title="plsconfirmsuk" :close-on-press-escape="false"
                 :wrapperClosable="false" :visible.sync="drawer5" direction="rtl">
        <div class="darwer-box">
          <el-descriptions class="content-title" :column="1">
            <el-descriptions-item class="content-item" label="tips">{{
                $t("home.buytips")
              }}
            </el-descriptions-item>
            <el-descriptions-item class="content-item" label="상품명">{{
                goodsname
              }}
            </el-descriptions-item>
            <el-descriptions-item class="content-item" label="가격">{{ price }} USD</el-descriptions-item>
            <el-descriptions-item class="content-item" label="월" :span="2">{{
                month
              }}
            </el-descriptions-item>
          </el-descriptions>
          <el-form :model="form2" :rules="rules2" ref="ruleForm2" label-position="top" size="medium">
            <el-form-item :label="$t('home.phone')" prop="phone">
              <el-input v-model="form2.phone"></el-input>
            </el-form-item>
          </el-form>
          <el-button style="width: 100%" type="primary" round
                     @click="topayment">{{ $t("home.buynow") }}
          </el-button>
        </div>
      </el-drawer>
    </template>
    <div v-else class="subscribe-empty">
      <!-- <p style="margin-top: 45vh">There are no subscriptions yet, please hurry to buy it</p> -->
      <!--        <p style="margin-top: 45vh">아직 구독이 안 되었으니 서둘러 구입해 주세요</p>-->
      {{ $t("subscribe.buyit") }}
    </div>
    <toBuy
        ref="toBuyRef"
        @goPay="goPay"
        :form1Obj="form1"
        :skuFilterList="skuFilterList"
    />
    <goPay
        ref="goPayRef"
        @closeToBuy="closeToBuy"
        @openBillDetails="openBillDetails"
        :form1Obj="form1"
        :formObj="form"
        :goodsname="goodsname"
        :discountCodeFlag="discountCodeFlag"
         pageName="subscribe"
    />
    <billingDetails
        ref="billingDetails"
        :form1Obj="form1"
    />
  </div>
</template>

<script>
import {
  userAllTicket,
  getGoodsspuById,
  orderRenew,
  calprice,
  carinforesetpwd,
  carinforeminder,
  paytypeall,
  insertWorkorder,
  payssion,
  stripe,
  getnfcodelink,
  getUserActiveSubscription
} from "@/request/requests";
import {
  getUserInfo,
  formatObj,
  isEmpty,
  MessageError,
  MessageInfo,
  MessageSuccess,
  startLoading,
  aminuteLoading,
  nfstartLoading,
} from "@/util/util";
import {
  isNumber,
  isEmail
} from "@/util/validate";
// import { Icon } from 'ant-design-vue';

// const IconFont = Icon.createFromIconfontCN({
//     scriptUrl: 'https://at.alicdn.com/t/c/font_3778069_0whrgs2ck2jr.js',
// });
import toBuy from "./home/toBuy";
import goPay from "./home/goPay";
import billingDetails from "./home/billingDetails";
export default {
  components: {
    // IconFont,
    toBuy,
    goPay,
    billingDetails
  },
  name: "subscribe",
  data() {
    let validateEmail = (rule, value, callback) => {
      if (!isEmail(value)) {
        // callback(new Error('Email ERROR!'));
        // callback(new Error('이메일 오류!'));
        callback(new Error(this.$t("home.emailerror")));
      } else {
        callback();
      }
    };
    let validateNumber = (rule, value, callback) => {
      if (!isNumber(value)) {
        callback(new Error("CVV ERROR!"));
      } else {
        callback();
      }
    };
    return {
      quotaData:{},
      submitPreventDouble:false,
      paramsObj:{},
      spu:'',
      goodsname:'',
      payOptions: [],
      skuFilterList:[],
      form1:{
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: "",
      },
      priceObj:{
        price:0,
        month:'',
        giftstimes:0,
      },
      discountCodeFlag:false,
      codelink: "",
      showlinkbt: false,
      showjoin: false,
      temp: "",
      userinfo: "",
      userTickets: [],
      sku: "",
      drawer1: false,
      drawer3: false,
      drawer4: false,
      drawer5: false,
      plsconfirmsuk: this.$t("home.Pleaseconfirmsuk"),
      payReslutIcon: "https://kilogod.oss-cn-shenzhen.aliyuncs.com/alongshare/paysuccess.png",
      // payReslutTitle:"Payment succeeded",
      payReslutTitle: this.$t("subscribe.paymentsucceeded"),
      price: "",
      seatno: "", //当前座位号
      originalprice: "",
      month: "",
      giftstimes: "",
      form: this.initform(),
      rules: {
        content: [{
          required: true,
          message: "Please enter the Email",
          trigger: "blur",
        },],
      },
      rules1: {
        // skuid :[
        //     {required: true, message: 'Please select a month', trigger: 'blur'},],
        // num :[
        //     {required: true, message: 'Please select the number of screens', trigger: 'blur'},],
        // buytype :[
        //     {required: true, message: 'Please select the purchase type', trigger: 'blur'},],
        // paycode :[
        //     {required: true, message: 'Please select the payment method', trigger: 'blur'},],
        skuid: [
          // { required: true, message: 'Please select a month', trigger: 'blur' },],
          // { required: true, message: '월을 선택하세요.', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.month"),
            trigger: "blur",
          },
        ],
        num: [
          // { required: true, message: 'Please select the number of screens', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.number"),
            trigger: "blur",
          },
        ],
        buytype: [
          // { required: true, message: 'Please select the purchase type', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.purchase"),
            trigger: "blur",
          },
        ],
        paycode: [
          // { required: true, message: 'Please select the payment method', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.payment"),
            trigger: "blur",
          },
        ],
      },
      form3: this.initform3(),
      rules3: {
        name: [
          // { required: true, message: 'Please enter Name on card', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.name"),
            trigger: "blur",
          },
        ],
        cardnumber: [
          // { required: true, message: 'Please enter Card number', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.card"),
            trigger: "blur",
          },
        ],
        cvv: [{
          required: true,
          message: this.$t("subscribe.cvv"),
          trigger: "blur",
        },
          {
            validator: validateNumber,
            trigger: "blur"
          },
        ],
        date: [
          // { required: true, message: 'Please enter Expiry date', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("subscribe.expirydate"),
            trigger: "blur",
          },
        ],
      },
      form2: this.initform2(),
      rules2: {
        firstname: [
          // { required: true, message: 'please enter first name', trigger: 'blur' },],
          // { required: true, message: '이름을 입력하세요', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.firstname"),
            trigger: "blur",
          },
        ],
        lastname: [
          // { required: true, message: 'please enter lastname', trigger: 'blur' },],
          // { required: true, message: '성을 입력하세요.', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.lastname"),
            trigger: "blur",
          },
        ],
        company: [{
          required: true,
          message: "please enter company",
          trigger: "blur"
        },],
        // { required: true, message: '회사를 입력하십시오', trigger: 'blur' },],
        country: [
          // { required: true, message: 'please enter country', trigger: 'blur' },],
          // { required: true, message: '국가를 입력하십시오', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.country"),
            trigger: "blur",
          },
        ],
        state: [
          // { required: true, message: 'please enter state', trigger: 'blur' },],
          // { required: true, message: '국가/주', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.state"),
            trigger: "blur",
          },
        ],
        city: [
          // { required: true, message: 'please enter city', trigger: 'blur' },],
          // { required: true, message: '도시를 입력하십시오', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.city"),
            trigger: "blur",
          },
        ],
        address: [
          // { required: true, message: 'please enter address', trigger: 'blur' },],
          // { required: true, message: '주소를 입력하십시오', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.address"),
            trigger: "blur",
          },
        ],
        postalcode: [
          // { required: true, message: 'please enter postal code', trigger: 'blur' },],
          // { required: true, message: '우편번호를 입력하세요', trigger: 'blur' },],
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.zipcode"),
            trigger: "blur",
          },
        ],
        phone: [
          // { required: true, message: 'please enter phone', trigger: 'blur' },
          // { required: true, message: '전화를 입력하십시오', trigger: 'blur' },
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.phone"),
            trigger: "blur",
          },
        ],
        email: [
          // { required: true, message: 'Please enter email', trigger: 'blur' },
          // { required: true, message: '이메일을 입력하세요', trigger: 'blur' },
          {
            required: true,
            message: this.$t("home.pleaseenter") + " " + this.$t("home.emailaddress"),
            trigger: "blur",
          },
          {
            validator: validateEmail,
            trigger: "blur"
          },
        ],
      },
    };
  },
  methods: {
    isEmpty,
    openBillDetails(){
      this.$refs['billingDetails'].init();
    },
    closeToBuy(){
      this.$nextTick(()=>{
        this.$refs['toBuyRef'].closeDialog();
      })
    },
    updateSku(val) {
      this.skuFilterList = []
      let i = 0
      this.spu.skus.forEach((r) => {
        if (r.type == val) {
          let obj = {
            id: r.id,
            goodsid: r.goodsid,
            skuname: r.skuname,
            price: r.price,
            giftstimes: r.giftstimes,
          };
          this.skuFilterList.push(obj);
          if (i == 0) {
            this.form1.skuid = r.id;
            this.priceObj.price = r.price;
            this.priceObj.month = r.skuname;
            this.priceObj.giftstimes = r.giftstimes;
          }
          i++;
        }
      });
    },


    joinyoutube(url) {
      window.open(url, "target");
    },
    async getUserActiveSubscription(){
      let res = await getUserActiveSubscription();
      if(res.status == '200'){
        let data = res.data;
        if(!this.isEmpty(data)){
          this.quotaData = data;
          this.quotaData.nextResetDate = this.$moment(this.quotaData.nextResetDate).format('yyyy-MM-DD');
        }
      }
    },
    openurl(url) {
      url = this.codelink;
      window.open(url, "target");
    },
    copy() {
      let copyCon = document.getElementById("copyText");
      copyCon.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      // this.$message.success("复制成功！");
      this.$message.success("copy!");
    },
    openchat() {
      window.open("https://www.gosharegpt.com/list", "target");
    },
    gochat(){
      this.$router.push({ path: "/shareAI" });
    },
    async submitUser(ticketid, loginemail) {
      if ("" != this.form.content.trim() && null != this.form.content) {
        // this.$alert(this.$t("subscribe.submitYoutube")), '', {
        //   confirmButtonText: 'Confirm',
        //   callback: action => {
        //     this.$message({
        //       type: 'info',
        //       message: `action: ${ action }`
        //     });
        //   }
        // });
        this.operatorUser(ticketid);
        window.open(loginemail, "target");
        // this.showjoin = true;
      } else {
        MessageError("Please enter the Email");
        return;
      }
    },
    async operatorUser(ticketid) {
      this.form.userid = this.userinfo.id;
      this.form.ticketid = ticketid;
      // this.form.typeid = 5;
      this.form.typeid = 8;
      this.form.content = "Complete email:" + this.form.content;
      let res = await insertWorkorder(this.form);
      if (res.status == "200") {
        // MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
        // MessageSuccess("처리 상태가 제출되었습니다. 작업 주문서에서 처리 상태를 확인하십시오.")
        // MessageSuccess(this.$t("subscribe.processing")); 提交工单提示
        this.form = this.initform();
        this.$refs.ruleForm.clearValidate();
      } else {
        MessageError(res.msg);
      }
    },
    initform() {
      return {
        id: "", // 序号
        userid: "", // 用户id
        workorderno: "", // 工单号
        ticketid: "", // 车票id
        typeid: "", // 类型id
        content: "", // 工单内容
        status: "", // 状态
        reply: "", // 处理回复
        orderId: ""
      };
    },
    initform1() {
      return {
        goodsid: "",
        skuid: "",
        num: "",
        buytype: "",
        paycode: "",
        discountcode: ""

      };
    },
    initform2() {
      return {
        firstname: "",
        lastname: "",
        company: "",
        country: "",
        state: "",
        city: "",
        address: "",
        address1: "",
        postalcode: "",
        phone: "",
        email: "",
      };
    },
    initform3() {
      return {
        name: "",
        cardnumber: "",
        cvv: "",
        date: "",
        issave: "",
      };
    },
    playorder() {
      this.$refs.ruleForm3.validate((valid) => {
        if (valid) {
          let userInfo = getUserInfo();
          if (userInfo) {
            this.userinfo = JSON.parse(userInfo);
            this.toSubmitOrder();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async toSubmitOrder() {
      let session_id = this.$cookies.get("session_id");
      let data = {
        goodsid: this.form1.goodsid,
        skuid: this.form1.skuid,
        num: this.form1.num,
        buytype: "1",
        paycode: this.form1.paycode,
        discountcode: this.form1.discountcode,

        name: this.form3.name,
        cardnumber: this.form3.cardnumber,
        cvv: this.form3.cvv,
        date: this.form3.date,
        issave: this.form3.issave == true ? 1 : 0,

        userid: this.userinfo.id,
        sessionid: session_id,
      };
      let loading = aminuteLoading();
      let res = await orderRenew(data);
      if (res.status == "200") {
        this.closeAllDrawer();
        loading.close();
        this.drawer4 = true;
        this.payReslutIcon =
            "https://kilogod.oss-cn-shenzhen.aliyuncs.com/alongshare/paysuccess.png";
        // this.payReslutTitle="Payment succeeded"
        this.payReslutTitle = this.$t("subscribe.paymentsucceeded");
      } else {
        loading.close();
        this.drawer4 = true;
        this.payReslutIcon =
            "https://kilogod.oss-cn-shenzhen.aliyuncs.com/alongshare/payerror.png";
        this.payReslutTitle = res.msg
      }
      loading.close();
    },
    closeAllDrawer() {
      this.drawer1 = false;
      this.drawer3 = false;
      this.form1 = this.initform1();
      this.form3 = this.initform3();
      this.userAllTicketInfo();
    },
    updatePrice() {
      this.spu.skus.forEach((r) => {
        if (r.id == this.form1.skuid) {
          this.price = this.form1.num * r.price;
          this.originalprice = "";
          this.month = r.skuname;
          this.giftstimes = r.giftstimes;
        }
      });
    },
    async useDiscountcode() {
      let code = this.form1.discountcode.trim();
      if ("" == code || null == code) {
        // MessageError("Discount code cannot be empty!")
        MessageError(this.$t("subscribe.cannotempty"));

        return;
      }
      let userInfo = getUserInfo();
      if (userInfo) {
        this.userinfo = JSON.parse(userInfo);
        let data = {
          goodsid: this.form1.goodsid,
          skuid: this.form1.skuid,
          num: this.form1.num * 1,
          discountcode: this.form1.discountcode,
          userid: this.userinfo.id,
        };
        let loading = startLoading();
        let res = await calprice(data);
        if (res.status == "200") {
          if (0 != res.data && res.data < this.price) {
            this.originalprice = this.price;
            this.price = res.data;
          }
          loading.close();
        } else {
          MessageError(res.msg);
          loading.close();
        }
        loading.close();
      }
    },
    async soonbug() {

      this.$refs.ruleForm1.validate((valid) => {
        if (valid) {
          let userInfo = getUserInfo();
          if (userInfo) {
            this.userinfo = JSON.parse(userInfo);
            // if ("wintopay" == this.form1.paycode) {
            //   this.drawer3 = true;
            // } else {
            //   this.drawer5 = true;
            // }
            this.drawer5 = true;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
    topayment() {
      this.paramsObj = {};
      let form1 = formatObj(this.form1);
      let params = {
        pmid: "alipay_cn",
        amount: 0.07,
        description: this.goodsname + this.priceDataForm.price + this.priceDataForm.skuname,
        ...form1,
        userid: this.userinfo.id,
        sessionid: sessionStorage.getItem("session_id")
      }

      //订阅页面购买
      if(this.pageName=='subscribe'){
        this.paramsObj = {
          ...params,
          orderId: this.form.orderId,
          ticketid: this.form.ticketid
        }
      }else{
        //首页购买
        this.paramsObj = params;
      }

      if(this.submitPreventDouble){
        return
      }
      this.submitPreventDouble = true;
      if ("smailwallet" == this.form1.paycode||this.form1.paycode.includes('smailwallet')) {
        this.tostripe(this.paramsObj);
      } else if("only" == this.form1.paycode||this.form1.paycode.includes('only')){
        //显示Billing Details弹窗
        this.$emit("openBillDetails");
        this.submitPreventDouble = false;
      } else {
        this.topayssion(this.paramsObj);
      }
    },
    async tostripe(params){
      //   let session_id = sessionStorage.getItem("session_id");
      //   const params = {
      //   pmid: "alipay_cn",
      //   amount: 0.07,
      //   description: this.goodsname + this.price + this.month,
      //   goodsid: this.form1.goodsid,
      //   skuid: this.form1.skuid,
      //   num: this.form1.num,
      //   buytype: this.form1.buytype,
      //   paycode: this.form1.paycode,
      //   // paycode: "payssion_test",
      //   discountcode: this.form1.discountcode,

      //   firstname: this.form2.firstname,
      //   lastname: this.form2.lastname,
      //   company: this.form2.company,
      //   country: this.form2.country,
      //   state: this.form2.state,
      //   city: this.form2.city,
      //   address: this.form2.address,
      //   postalcode: this.form2.postalcode,
      //   phone: this.form2.phone,
      //   email: this.form2.email,

      //   name: this.form3.name,
      //   cardnumber: this.form3.cardnumber,
      //   cvv: this.form3.cvv,
      //   date: this.form3.date,
      //   issave: this.form3.issave == true ? 1 : 0,
      //   userid: this.userinfo.id,
      //   sessionid: session_id,
      // };
      const res = await stripe(params);
      let loading = startLoading();
      if (res.data.code == "10000") {
        const url =res.data.web_url+"&return_url="+encodeURIComponent("https://www.alongshare.com/")
        window.open(url, "_self");
      } else {
        loading.close();
        MessageError(res.msg);
      }
    },
    async toPayssion(params) {
      let loading = startLoading();
      const res = await payssion(params);
      if (res.status == 200) {
        window.open(res.data.redirect_url, "_self");
      } else {
        loading.close();
        MessageError(res.msg);
        this.submitPreventDouble = false;
        this.dataDiscountCodeFlag = false;
      }
    },
    async userAllTicketInfo() {
      let loading = startLoading();
      let res = await userAllTicket(this.userinfo.id);
      if (res.status == "200") {
        this.userTickets = res.data;
        // gpt密码处理
        for (let i = 0; i < this.userTickets.length; i++) {
          if (this.userTickets[i].goodsid == 8) {
            let seatno = this.userTickets[i].seatno + 1
            if (seatno % 2 == 0) {
              console.log("TCL: userAllTicketInfo -> kk", seatno)
              this.userTickets[i].loginpwd = seatno + this.userTickets[i].loginpwd
            } else {
              this.userTickets[i].loginpwd = this.userTickets[i].loginpwd + seatno
            }
          }
        }
        if (res.data.length > 0) {
          this.userTickets.forEach((r) => {
            r.ext1 = this.countTime(r.endTime);
          });
          this.temp = setInterval(() => {
            this.userTickets.forEach((r) => {
              r.ext1 = this.countTime(r.endTime);
            });
          }, 60000);
        }
        loading.close();
      } else {
        MessageError(res.msg);
        loading.close();
      }

      loading.close();
    },
    countTime(time) {
      //获取当前时间
      let date = new Date();
      let now = date.getTime();
      //设置截止时间
      let endDate = new Date(time);
      let end = endDate.getTime();
      //时间差
      let leftTime = end - now;
      //定义变量 d,h,m,s保存倒计时的时间
      let count;
      if (leftTime >= 0) {
        let d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        d = d < 10 ? "0" + d : d;
        let h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        h = h < 10 ? "0" + h : h;
        let m = Math.floor((leftTime / 1000 / 60) % 60);
        m = m < 10 ? "0" + m : m;
        // let s = Math.floor(leftTime / 1000 % 60);
        // s = s < 10 ? "0" + s : s
        // count = d + ' Days ' + h + ' Hours ' + m + ' minute ' + s + ' second'
        count = d + " Days " + h + " Hours " + m + " minute ";
      }
      // console.log(count);
      return count;
    },
    async getGoodsspuByIdInfo(id, seatno) {
      let loading = startLoading();
      let res = await getGoodsspuById(id);
      if (res.status == "200") {
        this.seatno = seatno;
        this.spu = res.data;
        this.goodsname = this.spu.goodsname;
        this.form1 = {
          goodsid: this.spu.id,
          skuid: this.spu.skus[0].id,
          num: 1,
          buytype: "1",
          paycode: this.payOptions[0].value,
          discountcode: ""
        };
        this.$nextTick(()=>{
          this.$refs['toBuyRef'].init(formatObj(this.spu))
        })
        loading.close();
      } else {
        MessageError(res.msg);
        loading.close();
      }
      loading.close();
    },
    /**
     * @param priceObj 价格对象
     * @param form1
     * @param discountCodeFlag 折扣码是否已经生效 true/false
     */
    goPay(priceObj,form1,discountCodeFlag){
      this.discountCodeFlag = discountCodeFlag;
      this.form1 = form1;
      this.$nextTick(()=>{
        this.$refs['goPayRef'].init(priceObj);
      })
    },
    resetpwd(val) {
      // this.$confirmel('The original password for this operation will no longer be used, whether to continue?', 'Tips', {
      this.$confirmel(
          this.$t("subscribe.originalpassword"),
          this.$t("luckdraw.tips"), {
            // confirmButtonText: 'Confirm',
            confirmButtonText: this.$t("luckdraw.comfirm"),
            // cancelButtonText: 'Cancel',
            cancelButtonText: this.$t("luckdraw.cancel"),

            type: "warning",
          }
      )
          .then(() => {
            this.toResetpwd(val);
          })
          .catch(() => {
            // MessageInfo("Canceled");
            MessageInfo(this.$t("luckdraw.cancel"));
          });
    },
    async toResetpwd(val) {
      let data = {
        carid: val.carid,
      };
      let loading = startLoading();
      let res = await carinforesetpwd(data);
      if (res.status == "200") {
        MessageSuccess(res.msg);
        this.userAllTicketInfo();
        loading.close();
      } else {
        MessageError(res.msg);
        loading.close();
      }
      loading.close();
    },
    async toResetpwd1(val) {
      if (
          !
              /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/
                  .test(
                      val.loginpwd
                  )
      ) {
        // MessageError('The password meets uppercase and lowercase letters, numbers and special characters, any combination of three of them, and the length is between 8 and 16!');
        MessageError(this.$t("subscribe.passwordmeets"));

        return;
      } else {
        let data = {
          carid: val.carid,
          loginpwd: val.loginpwd,
        };
        let loading = startLoading();
        let res = await carinforesetpwd(data);
        if (res.status == "200") {
          MessageSuccess(res.msg);
          this.userAllTicketInfo();
          loading.close();
        } else {
          MessageError(res.msg);
          loading.close();
        }
        loading.close();
      }
    },
    async remind(val) {
      let loading = startLoading();
      let res = await carinforeminder(val.carid);
      if (res.status == "200") {
        MessageSuccess(res.msg);
        loading.close();
      } else {
        MessageError(res.msg);
        loading.close();
      }
      loading.close();
    },
    async paytypeallInfo() {
      let res = await paytypeall();
      if (res.status == "200") {
        this.payOptions = res.data;
      } else {
        MessageError(res.msg);
      }
    },
    async getlink(email) {
      // console.log("TCL: getlink -> email", email)
      // email = 'mjkii@alongshare.online'
      let loading = nfstartLoading();
      let res = await getnfcodelink(email);
      // let res = {}
      // res.code = 200
      // const link = ""
      if (res.code == "200") {
        const link = res.result.link;
        if (link) {
          // let loading = startLoading();
          this.codelink = link;
          this.showlinkbt = true;
          loading.close();
          this.openurl(link);
        } else {
          MessageError("No code, please try again");
          this.showlinkbt = false;
          alert("No code, Please resend the code");
          loading.close();
        }
      } else {
        MessageError("netflix Code Error");
      }
      setTimeout(() => loading.close(), 5000);
    },
  },
  mounted() {
    let userInfo = getUserInfo();
    if (userInfo) {
      this.userinfo = JSON.parse(userInfo);
      this.userAllTicketInfo();
      this.paytypeallInfo();
      this.getUserActiveSubscription();
    }
  },
  destroyed() {
    clearInterval(this.temp);
    // console.log(this.temp,"销毁")
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/subscribe.scss";

.dashed {
  width: 1px;
  margin-top: 10px;
  height: 40px;
  background-image: linear-gradient(to bottom,
      #ffffff 0%,
      #8e8e8e 50%,
      transparent 30%);
  background-size: 8px 2px;
  background-repeat: repeat-y;
}

.dashed-green {
  margin-left: -10%;
  width: 120%;
  height: 2px;
  background-image: linear-gradient(to right,
      #ffffff 0%,
      #8e8e8e 50%,
      transparent 30%);
  background-size: 8px 8px;
  background-repeat: repeat-x;
}

.psdinput > > > .el-input__inner {
  border: 0;
  height: 15px;
  width: 200px;
  text-align: right;
  background-color: #f6f6f6;
  font-size: 12px!important;
}

::v-deep .el-input__inner{
  font-size: 12px!important;
}

.psdinput > > > .el-input__suffix {
  top: -10px;
}

.resetpwd {
  height: 25px;
  line-height: 2px;
  border: 1px solid #8e8e8e;
  background-color: #ffffff;
  color: #8e8e8e;
}

.skuname {
  border-left: 1px solid #dcdfe6;
  border-radius: 10px;
  margin-left: 3%;
  margin-top: 10px;
}

.textdesc {
  word-break: break-all;
  padding: 5px;
  -webkit-transform: scale(0.8);
}

.darwer-box {
  color: #000;
  padding: 20px;
  height: 90vh;
  position: relative;
}

/**获取链接class**/
.gtlink {
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: underline;
  padding: 10px 10px 10px 0;
}

.pass-input{
  text-align: right;
  @media (max-width:1669px) {
    text-align: left;
    width:100%;
  }

}

</style>